export default "__VITE_ASSET__jVcvxyun__"